import { Button } from '@sorrem-client/ui/components';
import type { Proclamation } from './proclamation';
import styles from './IntroProclamationPage.module.scss';

interface IntroProclamationPageProps {
    proclamation: Proclamation;
    isContinuing: boolean;
    onContinue: () => void;
}

/** First-login intro: the Dominion's proclamation, presented as temple doctrine. */
export function IntroProclamationPage({ proclamation, isContinuing, onContinue }: IntroProclamationPageProps): JSX.Element {
    return (
        <div className={styles.screen}>
            <div className={styles.backgroundGlow} />

            <article className={styles.scroll} aria-label="Proclamation">
                <header className={styles.header}>
                    <p className={styles.kicker}>Read in every temple of Sorrem</p>
                    <h1 className={styles.title}>{proclamation.title}</h1>
                </header>

                <div className={styles.body}>
                    {proclamation.paragraphs.map((paragraph) => (
                        <p key={paragraph} className={styles.paragraph}>{paragraph}</p>
                    ))}

                    <div className={styles.litany}>
                        {proclamation.litany.map((line) => (
                            <p key={line} className={styles.litanyLine}>{line}</p>
                        ))}
                    </div>

                    <p className={styles.closing}>{proclamation.closing}</p>
                </div>

                <footer className={styles.footer}>
                    <Button type="button" variant="secondary" onClick={onContinue} disabled={isContinuing}>
                        Continue
                    </Button>
                </footer>
            </article>
        </div>
    );
}
